<template>
  <div v-bind:class="amplifyUI.formSection">
    <div id="payment_entry" v-show="!paid_status">
      <h3 class="text-center">Let's Do This!</h3>
      <div id="intro"><p>Freelance Developer Coach provides the tools and guidance to super-charge your career!</p>
        <p>But first, we need to regular-charge your card.</p>
        <p>Cancel within 60 days for a full refund</p>
      </div>

      <div id="prices">
          <div id="billing">
            Quarterly Billing <p-switch v-model="annualBilling"></p-switch> Annual Billing
          </div>
            <h5>Price per month: <b>${{monthlyPrice}}</b></h5>
            <h5>Due today: <b>${{dueToday}}</b></h5>
            <button id="checkout" @click="checkout" class="btn btn-success" type="submit">Pay with credit or debit card</button>
      </div>
      
    </div>

    <div v-show="paid_status" v-bind:class="amplifyUI.sectionHeader">Payment Captured - Create Account</div>
    <div v-show="paid_status" v-bind:class="amplifyUI.sectionBody">
      <div class="Form__formField___2GVQY">
        <div class="Input__inputLabel___2YLi4">Email</div>
        <input v-model="email" disabled placeholder="Affiliate ID" type="string" class="Input__input___1xOOi">
      </div>
      <div class="Form__formField___2GVQY">
        <div class="Input__inputLabel___2YLi4">Affiliate ID (optional)</div>
        <input v-model="affiliate_id" v-bind:disabled="affiliateReadonly" placeholder="Affiliate ID" type="string" class="Input__input___1xOOi">
      </div>
      <div class="Form__formField___2GVQY">
        <div class="Input__inputLabel___2YLi4">Password *</div>
        <input v-model="password" placeholder="Password" type="password" class="Input__input___1xOOi">
      </div>

    </div>
    <div v-bind:class="amplifyUI.sectionFooter">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <button v-show="paid_status" v-bind:class="amplifyUI.button" v-on:click="signUp">Create Account</button>
      </span>
      <span v-bind:class="amplifyUI.sectionFooterSecondaryContent">
        <a v-bind:class="amplifyUI.a" v-on:click="signIn">Have an Account? Sign In</a>
      </span>
    </div>
    <div class="error" v-if="error_message">
      {{ error_message }}
    </div>
  </div>
       
</template>
<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import Vue from "vue";
import * as AmplifyUI from "@aws-amplify/ui";
import { Auth } from "aws-amplify";
import VueCookie from "vue-cookie";
import Switch from '../UIComponents/Switch'
import {paymentStripeAPI} from "../../api/api"

Vue.use(VueCookie);

export default {
  name: "SignUp",
  components: {
    [Switch.name]: Switch
  },

  async beforeCreate() {
   
    if (process.env.NODE_ENV == "development") {
      console.log("development");
      this.development = "sandbox";
    } else {
      console.log("production");
      this.development = "production";
    }
    try {
      await Auth.currentAuthenticatedUser();
      this.signedIn = true;
    } catch (err) {
      this.signedIn = false;
    }
    AmplifyEventBus.$on("authState", info => {
      if (info === "signedIn") {
        this.signedIn = true;
      } else {
        this.signedIn = false;
      }
    });
  },
  watch: {
    annualBilling(newValue) {
      if (newValue) {
        this.monthlyPrice = 5;
        this.dueToday = 60;
      } else {
        this.monthlyPrice = 7;
        this.dueToday = 21;
      }
    }
  },
  data() {
    return {
      email: "test-email",
      password: "",
      affiliate_id: "",
      affiliateReadonly: false,
      development: "production",
      paid_status: false,
      amplifyUI: AmplifyUI,
      error_message: "",
      signedIn: false,
      annualBilling: false,
      monthlyPrice: 7,
      dueToday: 21,
      charge_token: "",
      charge_id: ""
    };
  },
  mounted() {
    let affiliate_cookie = this.$cookie.get("affiliate_id")
    console.log(affiliate_cookie);
    if (affiliate_cookie != null && affiliate_cookie != "") {
      this.affiliate_id = affiliate_cookie
      this.affiliateReadonly = true;
    }
  },

  methods: {
    signUp: function() {
      if (!this.validate()) {
        return null;
      }

      if (this.charge_id == ""){
        let payment = {
          "amount": this.dueToday * 100,
          "currency": "usd",
          "source": this.charge_token,
          "plan_level": "Plan",
          "affiliate_id": this.affiliate_id,
          "email": this.email
        }

        paymentStripeAPI(payment).then(data => {
          console.log(data)
          this.charge_id = data.charge_id;
          this.createAccount()
        })
      } else {
        this.createAccount()
      }

    },
    createAccount() {
      let user = {
        username: this.email,
        password: this.password
      };

      Auth.signUp(user)
        .then(data => {
          AmplifyEventBus.$emit("localUser", data.user);
          if (data.userConfirmed === false) {
            return AmplifyEventBus.$emit("authState", "confirmSignUp");
          }
          return AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch(e => this.setError(e));
    },
    signIn: function() {
      AmplifyEventBus.$emit("authState", "signedOut");
    },

    validate: function() {
      let allValid = true;

      return allValid;
    },

    setError: function(e) {
      this.error_message = e.message || e;
    },

    checkout: function() {
      //stripe payment
      this.$checkout.open({
        name: "Payment Details",
        currency: "USD",
        amount: this.dueToday * 100,
        token: token => {
          console.log("Charged " + this.dueToday * 100)
          console.log("token " + JSON.stringify(token));
          this.charge_token = token.id;
          this.email = token.email;
          this.paid_status = true;
        }
      });
    }
  }
};
</script>

<style>
  body {
    margin: 0;
  }

  #intro {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
  }
  #payment_entry {
    margin-bottom: 10px;
  }
  #billing {
    padding-top: 5px;
    padding-bottom: 10px;
    width: 100%;
    text-align: center;
  }
  #prices {
    padding-top: 10px;
    margin-top: 15px;
    margin-bottom: 25px;
    border: 1px black solid;
    border-radius: 8px;
    text-align: center;
    padding-bottom: 10px;
  }
  #checkout {
    width: 260px;
  }
</style>
